import { Component } from '@angular/core';

@Component({
  selector: 'app-business-rules',
  templateUrl: './business-rules.component.html',
  styleUrl: './business-rules.component.scss'
})
export class BusinessRulesComponent {

}
